import React, { useEffect, useState } from "react";

export const CollectionSidebar = ({ isVisible, filters, metaobject_filters, toggleSidebar }) => {
    const FilterList = ({ filter, metaobjectFilter }) => (
        <div className="pb-5 mb-5 border-b border-[#eceeef]" style={{ order: metaobjectFilter.sort_order }}>
            <div className="b4--bold">{metaobjectFilter.display_name}</div>
            <div className="filters__list flex flex-col space-y-2 mt-4 b4">
                {filter.values.map((value, index) => (
                    <label
                        className="flex items-center cursor-pointer"
                        key={index}
                        x-on:click={`filter('${filter.key}', '${value.key}');`}
                    >
                        <input
                            type="checkbox"
                            value={value.key}
                            className="form-checkbox cursor-pointer"
                        />
                        <span className="ml-2">
                            {value.label}
                        </span>
                        <span className="ml-auto">
                            {value.count}
                        </span>
                    </label>
                ))}
            </div>
        </div>
    );

    const FilterButton = ({ filter, metaobjectFilter }) => {
        const [visibleCount, setVisibleCount] = useState(metaobjectFilter.display_limit);
        const [showMore, setShowMore] = useState(true);

        const handleShowMore = () => {
            setVisibleCount((prevCount) => prevCount + metaobjectFilter.display_limit);
            setShowMore(false);
        };

        const handleShowLess = () => {
            setVisibleCount(metaobjectFilter.display_limit);
            setShowMore(true);
        };

        const visibleButtons = metaobjectFilter.filter_buttons.slice(0, visibleCount);
        const hasMore = visibleCount < metaobjectFilter.filter_buttons.length;

        return (
            <div className="flex flex-col pb-5 mb-5 border-b border-[#eceeef]" style={{ order: metaobjectFilter.sort_order }}>
                <div className="b4--bold">{metaobjectFilter.display_name}</div>
                <div className="flex flex-wrap gap-x-3 gap-y-5 mt-4">
                    {visibleButtons.map((value) => (
                    <div
                        className="filters__button relative cursor-pointer flex flex-col items-center justify-center text-center max-w-[60px] h-full w-full"
                        key={value.key}
                        x-on:click={`filter('${filter.key}', '${value.button_name}');`}
                    >
                        <input
                            type="checkbox"
                            value={value.button_name}
                            className="absolute opacity-0 cursor-pointer"
                        />
                        <div className="filters__button--wrapper border border-transparent p-1">
                        {value.colour ? (
                            <div className="filters__button--item w-full h-full" style={{ backgroundColor: value.colour }}></div>
                        ) : (
                            <img className="filters__button--item" loading="lazy" src={value.image} alt={value.image.alt} width="120" height="auto" />
                        )}
                        </div>
                        <p className="b3">
                            {value.display_name}
                        </p>
                    </div>
                    ))}
                </div>
                {hasMore ? (
                    <button className="filters__show-hide mt-4" onClick={handleShowMore}>
                        {`Show All ${metaobjectFilter.display_name}s (${filter.values.length})`}
                    </button>
                ) : !showMore ? (
                    <button className="filters__show-hide mt-4" onClick={handleShowLess}>
                        {`Show Less`}
                    </button>
                ) : null}
            </div>
        )
    };
      
      const FilterColour = ({ filter }) => (
        <div className="pb-5 mb-5 border-b border-[#eceeef]">
          <div className="b4--bold">{filter.label}</div>
          <div className="flex flex-wrap gap-x-3 gap-y-5 mt-4">
            {filter.values.map((value) => (
              <div
                className="filters__colour relative cursor-pointer flex flex-col items-center justify-center text-center max-w-[60px] h-full w-full"
                key={value.key}
                x-on:click={`filter('${filter.key}', '${value.key}');`}
              >
                <input
                    type="checkbox"
                    value={value.key}
                    className="absolute opacity-0 cursor-pointer"
                />
                <div className="filters__colour--wrapper border border-transparent p-1 ">
                  <div className={`filters__colour--item filters__colour--${value.label.toLowerCase()} w-full h-full`}></div>
                </div>
                <p className="b3">
                    {value.label}
                </p>
              </div>
            ))}
          </div>
        </div>
    );

    const FilterSize = ({ filter, metaobjectFilter }) => {
        const displayLimit = metaobjectFilter.display_limit ? metaobjectFilter.display_limit : filter.values.length
        const [visibleCount, setVisibleCount] = useState(displayLimit);
        const [showMore, setShowMore] = useState(true);

        const handleShowMore = () => {
            setVisibleCount((prevCount) => prevCount + displayLimit);
            setShowMore(false);
        };

        const handleShowLess = () => {
            setVisibleCount(displayLimit);
            setShowMore(true);
        };

        const visibleFilters = filter.values.slice(0, visibleCount);
        const hasMore = visibleCount < filter.values.length;

        return (
            <div className="flex flex-col pb-5 mb-5 border-b border-[#eceeef]" style={{ order: metaobjectFilter.sort_order }}>
                <div className="b4--bold">{metaobjectFilter.display_name}</div>
                <div className="grid grid-cols-4 mt-4">
                    {visibleFilters.map((value) => (
                        <div
                            className="filters__size relative cursor-pointer h-full w-full p-2"
                            key={value.key}
                            x-on:click={`filter('${filter.key}', '${value.key}')`}
                        >
                            <input
                                type="checkbox"
                                value={value.key}
                                className="absolute opacity-0"
                            />
                            <button className="filters__size--button px-0 capitalize w-full h-10 flex items-center justify-center text-[#00263E] bg-[#ECEBEB] border">
                                {value.label}
                            </button>
                        </div>
                    ))}
                </div>
                {hasMore ? (
                    <button className="filters__show-hide mt-4" onClick={handleShowMore}>
                        {`Show All ${metaobjectFilter.display_name}s (${filter.values.length})`}
                    </button>
                ) : !showMore ? (
                    <button className="filters__show-hide mt-4" onClick={handleShowLess}>
                        {`Show Less`}
                    </button>
                ) : null}
            </div>
        )
    };

    const renderFilterValues = (filter, metaobjectFilters) => {
        const metaobjectFilter = metaobjectFilters.find(value => value.filter_name.toLowerCase() === filter.key.toLowerCase());
      
        if (filter.key === 'named_tags.swatch' || filter.key === 'named_tags.fabrtype') {
            return metaobjectFilter ? <FilterButton filter={filter} metaobjectFilter={metaobjectFilter} /> : <FilterColour filter={filter} />;
        } else if (filter.key === 'options.size') {
            return metaobjectFilter ? <FilterSize filter={filter} metaobjectFilter={metaobjectFilter} /> : <FilterSize filter={filter} metaobjectFilter={{ sort_order: 0, display_name: filter.label }} />;
        } else {
            return metaobjectFilter ? <FilterList filter={filter} metaobjectFilter={metaobjectFilter} /> : <FilterList filter={filter} metaobjectFilter={{ sort_order: 0, display_name: filter.label }} />;
        }
    };

    return (
        <>
            <div className={`fixed top-0 w-full h-full bg-black z-50 opacity-20 ${isVisible ? '' : 'hidden'}`} onClick={toggleSidebar}></div>
            <div className={`collection-sidebar fixed top-0 left-0 overflow-y-auto w-full md:w-[350px] h-full bg-white shadow-lg transition-transform z-50 transform ${isVisible ? 'translate-x-0' : '-translate-x-full'}`}>

                <div className={'facets flex flex-col pt-[40px] px-4'}>
                    {filters.map((filter) => (
                        <React.Fragment key={filter.key}>
                            {renderFilterValues(filter, metaobject_filters)}
                            {/* <hr className={'my-[18px]'} /> */}
                        </React.Fragment>
                    ))}
                </div>

                <div className="text-center p-4 border-t border-[#BBBBBD]">
                    <button className="button button-tertiary w-full" x-on:click={`clear`}>Clear Filter</button>
                </div>
            </div>
        </>
    );
};
